module.exports = __webpack_public_path__ + "img/stu-pre-exam-bar-bg-right.a2085d60.svg";